/*  THE SCREENSHOT, FULL SIZE. Press it and it opens over the page.

    THE BANK SHOT IS 620px WIDE ON THE PAGE and the thing it is proving is a list of a
    hundred and twenty preset names in 11px type. At that size it says "here is the bank
    in Analog Lab" and nothing more, which is the right job for it in the layout and the
    wrong one for somebody who actually wants to read what is in the bank. So the small
    one stays small and the full capture is one press away.

    IT LOADS THE BIG FILE ONLY WHEN ASKED. The button carries the full size URL in a data
    attribute and the overlay is built on first press, so a page nobody clicks through
    pays nothing for this.

    THE OPEN TRANSITION IS DRIVEN BY A FORCED REFLOW, NOT BY requestAnimationFrame. The
    first version added the is-open class inside a rAF callback so the transition would
    have a from state to run out of. That is the usual trick and it has a nasty failure
    mode here: the overlay is unhidden and the page is scroll locked on the same tick, and
    if the frame never arrives, the class never lands. Opacity stays 0 and the visitor is
    left looking at a frozen page with an invisible modal over it and no way to reach the
    close button. Browsers withhold frames from backgrounded and throttled tabs, and this
    was reproduced first try in an embedded viewer. Reading offsetWidth flushes layout
    synchronously, which gives the transition the same from state without ever handing
    control back to the frame scheduler.

    IT CLOSES EVERY WAY SOMEBODY WOULD TRY: the close button, the backdrop, Escape, and
    the browser back button is not hijacked because no history entry is pushed.

    FOCUS GOES TO THE CLOSE BUTTON and comes back to the thumbnail afterwards, so this is
    usable without a mouse and does not dump keyboard focus at the top of the document.

    THE PAGE UNDERNEATH IS LOCKED while it is open, and the scroll position is restored
    rather than jumping to the top, which is what setting overflow hidden on body does on
    its own.  */
(function () {
  'use strict';

  var buttons = [].slice.call(document.querySelectorAll('[data-ev-zoom]'));
  if (!buttons.length) return;

  var box = null, img = null, caption = null, closeBtn = null, opener = null;
  var scrollY = 0, hideTimer = 0;

  function build () {
    box = document.createElement('div');
    box.className = 'ev-zoom';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.hidden = true;
    box.innerHTML =
      '<div class="ev-zoom-scrim" data-close></div>' +
      '<figure class="ev-zoom-fig">' +
        '<img alt="">' +
        '<figcaption></figcaption>' +
      '</figure>' +
      '<button type="button" class="ev-zoom-x" aria-label="Close">&times;</button>';
    document.body.appendChild(box);
    img = box.querySelector('img');
    caption = box.querySelector('figcaption');
    closeBtn = box.querySelector('.ev-zoom-x');

    closeBtn.addEventListener('click', close);
    box.querySelector('[data-close]').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (box && !box.hidden && e.key === 'Escape') close();
    });
  }

  function open (btn) {
    if (!box) build();
    clearTimeout(hideTimer);

    var thumb = btn.querySelector('img');
    opener = btn;
    img.src = btn.getAttribute('data-full') || (thumb && thumb.src) || '';
    img.alt = (thumb && thumb.getAttribute('alt')) || '';
    var cap = btn.getAttribute('data-caption') || '';
    caption.textContent = cap;
    caption.hidden = !cap;

    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollY + 'px';
    document.body.style.width = '100%';

    box.hidden = false;
    /*  flush layout so the transition has a from state. See the note above for why this
        is not a requestAnimationFrame.  */
    void box.offsetWidth;
    box.classList.add('is-open');
    closeBtn.focus();
  }

  function close () {
    if (!box || box.hidden) return;
    box.classList.remove('is-open');

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);

    /*  wait out the fade before hiding. A timer rather than transitionend, which never
        fires when motion is reduced and would leave this open forever.  */
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () { box.hidden = true; img.src = ''; }, 200);

    if (opener) { opener.focus(); opener = null; }
  }

  buttons.forEach(function (b) {
    b.addEventListener('click', function () { open(b); });
  });
})();